import { StyleSheet } from 'react-native';

import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        height: '100%'
    },
    iconClose: {
        position: 'absolute',
        top: 20,
        right: '5%'
    },
    scrollContainer: {
        paddingHorizontal: '20%'
    },
    assetDetail: {
        marginTop: Theme.primaryMargin
    },
    infoList: {
        marginBottom: '20%'
    },
    subTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.secondaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        marginTop: 6,
        letterSpacing: -0.1
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            position: 'absolute',
            right: 0,
            height: '100%',
            width: '35%',
            borderLeftWidth: 1,
            borderLeftColor: Theme.secondaryButtonBorderColor,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            // paddingTop: '4%'
        },
        iconClose: {
            position: 'absolute',
            top: '3%',
            right: '3%'
        },
        scrollContainer: {
            paddingHorizontal: '10%'
        }
    };
}

export default StyleSheet.create(baseStyles);
